import { Tab, Tabs } from '@material-ui/core';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const TimeSelector = ({ onTabClick, tabs, defaultIndex }) => {
  const [selectedTab, setSelectedTab] = useState(defaultIndex);
  const updateTabs = (event, value) => {
    setSelectedTab(value);
  };
  if (tabs !== undefined) {
    return (
      <div>
        <Tabs value={selectedTab} onChange={updateTabs} indicatorColor="primary" textColor="primary" centered>
          {tabs.map(({ bucketPeriod, bucketUnit, timePeriod, label, index, include_today }) => {
            return (
              <Tab
                onClick={() => onTabClick(bucketPeriod, bucketUnit, timePeriod, include_today)}
                value={index}
                label={label}
                key={label}
              />
            );
          })}
        </Tabs>
      </div>
    );
  }
  return <div></div>;
};

TimeSelector.propTypes = {
  onTabChange: PropTypes.func,
  onTabClick: PropTypes.func,
  tabs: PropTypes.array,
  defaultIndex: PropTypes.number,
};

TimeSelector.defaultProps = {
  onTabChange: () => {},
  onTabClick: () => {},
};

export default TimeSelector;
